import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";

const BackgroundSection = () => {
  const [currentTime, setCurrentTime] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [shuffledAudioUrls, setShuffledAudioUrls] = useState([]);
  const [shuffledVideoUrls, setShuffledVideoUrls] = useState([]);
  const [auth, setAuth] = useState({ username: '', password: '', token: null });
  const [message, setMessage] = useState('');
  const [protectedData, setProtectedData] = useState('');

  const videoTimeoutRef = useRef(null);

  const obfuscateUrl = (url) => btoa(url);
  const deObfuscateUrl = (encodedUrl) => atob(encodedUrl);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleAudioEnded = () => {
    setCurrentAudioIndex((prevIndex) =>
      prevIndex < shuffledAudioUrls.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handleVideoEnded = () => {
    clearTimeout(videoTimeoutRef.current);
    setCurrentVideoIndex((prevIndex) =>
      prevIndex < shuffledVideoUrls.length - 1 ? prevIndex + 1 : 0
    );
  };


	const lazyLoadCSS = (href) => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = href;
		document.head.appendChild(link);
	};

	const loadScriptAtEnd = (url) => {
		const script = document.createElement('script');
		script.src = url;
		script.async = true;
		script.onerror = () => console.error(`Failed to load ${url}`);
		document.body.appendChild(script); // Append script to the body
	};

	const initializeLazyLoading = () => {
		const cssFiles = [
			'https://cdn.gclite.org/login/css/synolog.css',
			'https://cdn.gclite.org/login/css/synolog.min.css',
		];
        const jsFiles = [
            "https://cdn.gclite.org/login/js/misc.js",
            "https://dreamx.red/webapi/entry.cgi?api=SYNO.Core.Desktop.SessionData&version=1&method=getjs&SynoToken=yes",
            "https://dreamx.red/webapi/entry.cgi?api=SYNO.Core.Desktop.Defs&version=1&method=getjs",
            "https://dreamx.red/webapi/entry.cgi?api=SYNO.Core.Desktop.JSUIString&version=1&method=getjs&lang=enu",
            "https://dreamx.red/webapi/entry.cgi?api=SYNO.Core.Desktop.UIString&version=1&method=getjs&lang=enu",
            "https://cdn.gclite.org/login/scripts/prototype-1.7.2/prototype.js",
            "https://cdn.gclite.org/login/scripts/ext-3/adapter/ext/ext-base.js",
            "https://cdn.gclite.org/login/scripts/ext-3/ext-all.js",
            "https://cdn.gclite.org/login/scripts/ext-3/ux/ux-all.js",
            "https://cdn.gclite.org/login/scripts/scrollbar/flexcroll.js",
            "https://cdn.gclite.org/login/synoSDSjslib/sds.js",
            "https://cdn.gclite.org/login/webman/desktop.js",
            "https://cdn.gclite.org/login/webman/security.cgi",
			"https://cdn.gclite.org/js/media.js",
		];

		// Load CSS files
		cssFiles.forEach(lazyLoadCSS);

		// Load JS files at the bottom of the page
		jsFiles.forEach(loadScriptAtEnd);
	};
    useEffect(() => {
        initializeLazyLoading();
    }, []);
  const handleRegister = async () => {
    try {
      // Mock registration logic
      setMessage('Registered successfully!');
    } catch (error) {
      setMessage('Registration failed!');
    }
  };

  const handleLogin = async () => {
    try {
      // Mock login logic
      const token = 'mock-token';
      setAuth((prev) => ({ ...prev, token }));
      setMessage('Logged in successfully!');
    } catch (error) {
      setMessage('Login failed!');
    }
  };

  const fetchProtectedData = async () => {
    try {
      const data = 'This is protected data!';
      setProtectedData(data);
    } catch (error) {
      setMessage('Failed to fetch protected data!');
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
      setCurrentDate(
        now.toLocaleDateString([], {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      );
    }, 1000);

    setShuffledAudioUrls(shuffleArray(['audio1.mp3', 'audio2.mp3'].map(obfuscateUrl)));
    setShuffledVideoUrls(shuffleArray(['video1.mp4', 'video2.mp4'].map(obfuscateUrl)));

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="App">
      <div id="sds-login" className="sds-login-dark">
        <div className="pre-load-x-window-br">
          <div id="sds-login-background">
            {shuffledVideoUrls.length > 0 && (
              <video
                loop={false}
                muted
                autoPlay
                playsInline
                preload="auto"
                src={deObfuscateUrl(shuffledVideoUrls[currentVideoIndex])}
                onEnded={handleVideoEnded}
                poster="https://cdn.gclite.org/webp/index-2.webp"
              ></video>
            )}
            {shuffledAudioUrls.length > 0 && (
              <audio
                src={deObfuscateUrl(shuffledAudioUrls[currentAudioIndex])}
                autoPlay
                onEnded={handleAudioEnded}
              ></audio>
            )}
          </div>
        </div>

        <div className="sds-login-logo">
          <a href="/">
            <img
              alt="sds-logo"
              width="56"
              src="https://dreamx-14fe8.web.app/images/logo.webp"
              style={{ float: 'left', margin: '2px 20px 10px 0px' }}
            />
          </a>
        </div>

        <div className="sds-login-welcome-info">
          <span className="time-tag">{currentTime}</span>
          <div className="current-date">{currentDate}</div>
        </div>

        <div>
          {!auth.token ? (
            <>
              <h2>Register</h2>
              <input
                type="text"
                placeholder="Username"
                value={auth.username}
                onChange={(e) => setAuth((prev) => ({ ...prev, username: e.target.value }))}
              />
              <input
                type="password"
                placeholder="Password"
                value={auth.password}
                onChange={(e) => setAuth((prev) => ({ ...prev, password: e.target.value }))}
              />
              <button onClick={handleRegister}>Register</button>

              <h2>Login</h2>
              <input
                type="text"
                placeholder="Username"
                value={auth.username}
                onChange={(e) => setAuth((prev) => ({ ...prev, username: e.target.value }))}
              />
              <input
                type="password"
                placeholder="Password"
                value={auth.password}
                onChange={(e) => setAuth((prev) => ({ ...prev, password: e.target.value }))}
              />
              <button onClick={handleLogin}>Login</button>
            </>
          ) : (
            <>
              <h2>Welcome, {auth.username}!</h2>
              <button onClick={fetchProtectedData}>Fetch Protected Data</button>
              <p>{protectedData}</p>
              <button onClick={() => setAuth({ username: '', password: '', token: null })}>
                Logout
              </button>
            </>
          )}
        </div>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default BackgroundSection;
